import React from 'react';


export type StatusVariant =

  | 'online'
  | 'offline'
  | 'reconnecting'

  | 'connected'
  | 'disconnected'
  | 'ready'
  | 'running'
  | 'unavailable'

  | 'queued'
  | 'accepted'
  | 'succeeded'
  | 'failed'
  | 'cancelled'
  | 'timed_out'

  | 'live'
  | 'building'
  | 'deploying';


interface StatusBadgeProps {

  status:
    StatusVariant |
    string;

  label?:
    string;

  size?:
    'sm' |
    'md';
}


export const StatusBadge:
React.FC<StatusBadgeProps> = ({
  status,
  label,
  size = 'sm'
}) => {

  const s =
    status.toLowerCase();


  let shell =
    'border-white/[0.07] bg-white/[0.035] text-slate-400';

  let dot =
    'bg-slate-500';


  if (
    [
      'online',
      'connected',
      'ready',
      'succeeded',
      'live'
    ].includes(
      s
    )
  ) {

    shell =
      'border-emerald-400/15 bg-emerald-400/[0.075] text-emerald-300';

    dot =
      'bg-emerald-400';
  }

  else if (
    [
      'running',
      'building',
      'deploying',
      'accepted'
    ].includes(
      s
    )
  ) {

    shell =
      'border-indigo-400/18 bg-indigo-400/[0.075] text-indigo-300';

    dot =
      'bg-indigo-400 animate-pulse';
  }

  else if (
    [
      'queued',
      'reconnecting'
    ].includes(
      s
    )
  ) {

    shell =
      'border-amber-400/16 bg-amber-400/[0.075] text-amber-300';

    dot =
      'bg-amber-400 animate-pulse';
  }

  else if (
    [
      'offline',
      'disconnected',
      'failed',
      'timed_out',
      'unavailable'
    ].includes(
      s
    )
  ) {

    shell =
      'border-rose-400/16 bg-rose-400/[0.07] text-rose-300';

    dot =
      'bg-rose-400';
  }

  else if (
    s ===
    'cancelled'
  ) {

    shell =
      'border-white/[0.06] bg-white/[0.025] text-slate-500';

    dot =
      'bg-slate-500';
  }


  const padding =
    size ===
      'sm'
      ? 'px-2 py-0.5 text-[10px]'
      : 'px-2.5 py-1 text-xs';


  return (

    <span
      className={`
        inline-flex
        items-center
        gap-1.5
        rounded-md
        border
        font-medium
        whitespace-nowrap
        ${padding}
        ${shell}
      `}
    >

      <span
        className={`
          w-1.5
          h-1.5
          rounded-full
          ${dot}
        `}
      />


      {label ||
       status.charAt(0).toUpperCase() +
       status.slice(1)}

    </span>
  );
};
